module.exports = __webpack_public_path__ + "static/media/3201082d-6476-409b-a1b3-7646256e8079.cfffa89c.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/3201082d-6476-409b-a1b3-7646256e8079.jpg
// module id = 811
// module chunks = 0